"use client";

import { useEffect } from "react";
import { captureFirstTouch } from "@/lib/first-touch";

/** 첫 유입 경로 쿠키 저장 (화면 출력 0 · 루트 레이아웃 한 곳 · src/lib/first-touch.ts). */
export default function FirstTouchCapture() {
  useEffect(() => {
    try {
      captureFirstTouch();
    } catch {
      /* 쿠키 차단 등 — 무시 */
    }
  }, []);
  return null;
}
